/* eslint-disable radix */
/* eslint-disable eqeqeq */

import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

const NOTE_PREVIEW_LENGTH = 60;

const escapeHtml = text => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const getNotePreviewHtml = html => {
  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!text) return '';

  const preview =
    text.length > NOTE_PREVIEW_LENGTH ? `${text.slice(0, NOTE_PREVIEW_LENGTH)}...` : text;

  return `<ul><li>${escapeHtml(preview)}</li></ul>`;
};

export const TextInput = props => {
  const {
    id,
    name,
    value,
    placeholder,
    handleUpdate,
    edited,
    disabled,
    showCounter,
    maxLength,
    error,
    renderValue,
    inputClassName,
  } = props;

  const [fieldValue, setFieldValue] = useState(value);
  const [isEditing, setIsEditing] = useState(false);

  const borderStyle = { borderColor: edited ? '#fdc126' : '' };
  const fieldClassName = ['form-control', inputClassName].filter(Boolean).join(' ');

  if (renderValue && !isEditing) {
    return (
      <Form>
        <Form.Group controlId={id}>
          <div
            className={fieldClassName}
            role="textbox"
            tabIndex={disabled ? -1 : 0}
            style={{ ...borderStyle, cursor: disabled ? 'default' : 'text' }}
            onClick={() => !disabled && setIsEditing(true)}
            onKeyDown={e => !disabled && e.key === 'Enter' && setIsEditing(true)}
          >
            {fieldValue ? (
              <div
                className="text-input-render-value"
                dangerouslySetInnerHTML={{ __html: getNotePreviewHtml(fieldValue) }}
              />
            ) : (
              placeholder || '-'
            )}
          </div>
          <span>{error}</span>
        </Form.Group>
      </Form>
    );
  }

  return (
    <Form>
      <Form.Group controlId={id}>
        <Form.Control
          type="text"
          name={name}
          className={inputClassName}
          value={fieldValue}
          placeholder={placeholder}
          autoFocus={renderValue && isEditing}
          onChange={e => setFieldValue(e.target.value || null)}
          onBlur={e => {
            handleUpdate(e.target.value || null);
            setFieldValue(e.target.value || null);
            if (renderValue) {
              setIsEditing(false);
            }
          }}
          style={borderStyle}
          disabled={disabled}
        />
        {showCounter && (
          <span>
            {fieldValue?.length || 0}/{maxLength}
          </span>
        )}
        <span>{error}</span>
      </Form.Group>
    </Form>
  );
};

export const TextAreaInput = props => {
  const { value, handleUpdate, edited } = props;

  const [fieldValue, setFieldValue] = useState(value);

  return (
    <Form.Group>
      <Form.Control
        as="textarea"
        rows={1}
        value={fieldValue}
        onChange={e => setFieldValue(e.target.value)}
        onBlur={e => {
          if (!isEmpty(e.target.value) && !isEqual(e.target.value, value)) {
            handleUpdate(e.target.value);
          } else {
            handleUpdate(value);
            setFieldValue(value);
          }
        }}
        style={{ borderColor: edited ? '#5dadae' : '' }}
      />
    </Form.Group>
  );
};

export const NumberInput = props => {
  const { value, handleUpdate, edited } = props;

  const [fieldValue, setFieldValue] = useState(parseInt(value));

  return (
    <Form>
      <Form.Group>
        <Form.Control
          type="number"
          value={fieldValue}
          onChange={e => setFieldValue(e.target.value)}
          onBlur={e => {
            if (!isEmpty(e.target.value) && e.target.value == value) {
              handleUpdate(parseInt(e.target.value));
            } else {
              handleUpdate(value);
              setFieldValue(value);
            }
          }}
          style={{ borderColor: edited ? 'red' : '' }}
        />
      </Form.Group>
    </Form>
  );
};
